import * as _ from 'lodash';
import { ComponentBase, ComponentOptionsBase } from '../../Common/ComponentBase';
import { Typeahead, TypeaheadApi, TypeaheadOptions } from '../../Widgets/Typeahead';
import { Utils } from '../../Utils/Utils';
import { FileUtils } from '../../Utils/FileUtils';
import { DateUtils } from '../../Utils/DateUtils';
import { StringUtils } from '../../Utils/StringUtils';
import { ArrayUtils } from '../../Utils/ArrayUtils';

export interface QuickSearchPanelComponentOptions extends ComponentOptionsBase {
    urlList: string;
    urlSelection: string;
    editElementId: string;
}

export type PlayerItem = {
    name: string;
    id: number;
}

export class QuickSearchPanelComponent extends ComponentBase<QuickSearchPanelComponentOptions> {
    private _typeaheadOptions: TypeaheadOptions;
    private _typeahead: Typeahead;

    constructor(options: QuickSearchPanelComponentOptions) {
        super(options);

        this.afterSelect = this.afterSelect.bind(this);
        this.getSource = this.getSource.bind(this);

        this._typeaheadOptions = {
            source: this.getSource,
            afterSelect: this.afterSelect,
            delay: 500,
            minLength: 2,
            items: 'all',
            fitToElement: true,
            overflowHeight: '200px'
        };
    }

    private afterSelect(item: PlayerItem): void {
        if (item) {
            var uri = URI(this._options.urlSelection + '/' + item.id.toString());
            //uri.setQuery('id', item.id.toString());
            location.href = uri.toString();
        }
    }

    private getSource(query: string, callback: (items: PlayerItem[]) => void): void {
        var uri = URI(this._options.urlList);
        uri.setQuery('query', query);
        
        FileUtils.readLocalJsonFile<PlayerItem[]>(uri.toString(), false)
            .then(json => {
                callback(json);
            });
    }

    init(): void {
        this._typeahead = new Typeahead(this._options.editElementId, this._typeaheadOptions);
    }
}


/** WEBPACK FOOTER **
 ** ./Typescript/Components/QuickSearchPanel/Component.ts
 **/